import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login, register } from "../../api/apiAuth";
import "./Login.css";

const Login = ({ onLogin, initialMode = "login" }) => {
    const navigate = useNavigate();
    const [modo, setModo] = useState(initialMode); // "login" | "registro"

    const [formLogin, setFormLogin] = useState({ username: "", password: "" });
    const [formRegistro, setFormRegistro] = useState({
        username: "",
        password: "",
        nombre: "",
        apellido: "",
        dni: "",
        fechaNacimiento: "",
    });

    const [error, setError] = useState("");
    const [exito, setExito] = useState("");
    const [loading, setLoading] = useState(false);

    const handleChangeLogin = (e) => {
        const { name, value } = e.target;
        setFormLogin((f) => ({ ...f, [name]: value }));
        setError("");
    };

    const handleChangeRegistro = (e) => {
        const { name, value } = e.target;
        setFormRegistro((f) => ({ ...f, [name]: value }));
        setError("");
    };

    const handleSubmitLogin = async (e) => {
        e.preventDefault();
        const username = formLogin.username.trim();
        const password = formLogin.password.trim();
        if (!username || !password) {
            setError("Ingresá usuario y contraseña.");
            return;
        }
        setLoading(true);
        setError("");
        try {
            const data = await login(username, password);
            onLogin(data);
        } catch (err) {
            setError(err.message || "Usuario o contraseña incorrectos.");
        } finally {
            setLoading(false);
        }
    };

    const handleSubmitRegistro = async (e) => {
        e.preventDefault();
        const { username, password, nombre, apellido, dni, fechaNacimiento } = formRegistro;
        if (!username || !password || !nombre || !apellido || !dni || !fechaNacimiento) {
            setError("Completá todos los campos.");
            return;
        }
        setLoading(true);
        setError("");
        setExito("");
        try {
            await register({ username, password, nombre, apellido, dni, fechaNacimiento });
            setExito("¡Cuenta creada! Ya podés iniciar sesión.");
            setFormRegistro({ username: "", password: "", nombre: "", apellido: "", dni: "", fechaNacimiento: "" });
            setModo("login");
        } catch (err) {
            setError(err.message || "No se pudo crear la cuenta.");
        } finally {
            setLoading(false);
        }
    };

    const cambiarModo = (nuevoModo) => {
        setModo(nuevoModo);
        setError("");
        setExito("");
        navigate(nuevoModo === "registro" ? "/registro" : "/login");
    };

    return (
        <main className="login-page">
            <section className="login-page__hero">
                <img
                    src="/logo192.png"
                    alt="Logo Sweet Medical"
                    className="admin-sidebar__logo"
                    style={{ width: '40px', height: '40px', objectFit: 'contain' }}
                />
                <p className="login-page__eyebrow">Sweet Medical</p>
                <h1>Gestioná tu centro médico de forma simple.</h1>
                <p className="login-page__description">
                    Administrá servicios, médicos, pacientes y turnos desde un único panel.
                </p>
                <button type="button" className="link-button login-page__back" onClick={() => navigate("/")}>
                    ← Volver al inicio
                </button>
            </section>

            <section className="login-page__panel">
                {modo === "login" ? (
                    <form className="login-card" onSubmit={handleSubmitLogin}>
                        <div>
                            <p className="login-page__eyebrow">Bienvenido</p>
                            <h2>Iniciar sesión</h2>
                            <span>Ingresá tus credenciales para continuar.</span>
                        </div>

                        {exito && <div className="form-success">{exito}</div>}

                        <label className="form-field">
                            <span>Usuario</span>
                            <input
                                type="text"
                                name="username"
                                placeholder="Usuario"
                                value={formLogin.username}
                                onChange={handleChangeLogin}
                                required
                            />
                        </label>

                        <label className="form-field">
                            <span>Contraseña</span>
                            <input
                                type="password"
                                name="password"
                                placeholder="Contraseña"
                                value={formLogin.password}
                                onChange={handleChangeLogin}
                                required
                            />
                        </label>

                        {error && <div className="form-error">{error}</div>}

                        <button className="primary-button" type="submit" disabled={loading}>
                            {loading ? "Entrando..." : "Entrar"}
                        </button>

                        <p className="login-toggle-text">
                            ¿No tenés cuenta?{" "}
                            <button type="button" className="link-button" onClick={() => cambiarModo("registro")}>
                                Creá una acá
                            </button>
                        </p>
                    </form>
                ) : (
                    <form className="login-card" onSubmit={handleSubmitRegistro}>
                        <div>
                            <p className="login-page__eyebrow">Nuevo paciente</p>
                            <h2>Crear cuenta</h2>
                            <span>Completá tus datos para registrarte.</span>
                        </div>

                        <label className="form-field">
                            <span>Nombre</span>
                            <input
                                type="text"
                                name="nombre"
                                placeholder="Nombre"
                                value={formRegistro.nombre}
                                onChange={handleChangeRegistro}
                                required
                            />
                        </label>

                        <label className="form-field">
                            <span>Apellido</span>
                            <input
                                type="text"
                                name="apellido"
                                placeholder="Apellido"
                                value={formRegistro.apellido}
                                onChange={handleChangeRegistro}
                                required
                            />
                        </label>

                        <label className="form-field">
                            <span>DNI</span>
                            <input
                                type="text"
                                name="dni"
                                placeholder="DNI"
                                value={formRegistro.dni}
                                onChange={handleChangeRegistro}
                                required
                            />
                        </label>

                        <label className="form-field">
                            <span>Fecha de nacimiento</span>
                            <input
                                type="date"
                                name="fechaNacimiento"
                                value={formRegistro.fechaNacimiento}
                                onChange={handleChangeRegistro}
                                required
                            />
                        </label>

                        <label className="form-field">
                            <span>Usuario</span>
                            <input
                                type="text"
                                name="username"
                                placeholder="Nombre de usuario"
                                value={formRegistro.username}
                                onChange={handleChangeRegistro}
                                required
                            />
                        </label>

                        <label className="form-field">
                            <span>Contraseña</span>
                            <input
                                type="password"
                                name="password"
                                placeholder="Contraseña (mín. 6 caracteres)"
                                value={formRegistro.password}
                                onChange={handleChangeRegistro}
                                required
                            />
                        </label>

                        {error && <div className="form-error">{error}</div>}

                        <button className="primary-button" type="submit" disabled={loading}>
                            {loading ? "Creando cuenta..." : "Crear cuenta"}
                        </button>

                        <p className="login-toggle-text">
                            ¿Ya tenés cuenta?{" "}
                            <button type="button" className="link-button" onClick={() => cambiarModo("login")}>
                                Iniciá sesión
                            </button>
                        </p>
                    </form>
                )}
            </section>
        </main>
    );
};

export default Login;